import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import "./SideBar.css";
import Logo from "./Logo";
import SofIcon from "./Icons";
import clsx from "clsx";
import { MdReceipt } from "react-icons/md";

const Sidebar: React.FC = () => {
  const [selectedMenu, setSelectedMenu] = useState("");
  const history = useHistory();

  useEffect(() => {
    console.log("LOCATION", history.location);
    if (history.location.pathname.indexOf("marine") > 0) {
      setSelectedMenu("marine");
    } else if (history.location.pathname === "/reports") {
      setSelectedMenu("reports");
    } else if (history.location.pathname === "/signout") {
      setSelectedMenu("profile");
    } else if (history.location.pathname === "/help") {
      setSelectedMenu("help");
    } else if (history.location.pathname === "/") {
      setSelectedMenu("dashboard");
    } else if (history.location.pathname === "/truck") {
        setSelectedMenu("truck");
    } else if (history.location.pathname === "/tank") {
        setSelectedMenu("tank");
    } else if (history.location.pathname === "/rail") {
      setSelectedMenu("rail");
    } else if (history.location.pathname === "/invoice") {
      setSelectedMenu("invoice");
    }
  }, [history.location]);

  console.log(selectedMenu, "selectedMenu");
  return (
    <nav className="sidebar">
      <div>
        <div className="logo-wrapper">
          <NavLink to="/">
            {/* <Logo className="logo" /> */}
            <img
              src="logo-yellow.svg"
              alt="QADWorks"
              style={{ width: 80.25, height: 48 }}
            />
          </NavLink>
        </div>
        <NavLink
          id="nav-dashboard"
          to="/"
          className={clsx(
            "sidebar-item",
            selectedMenu === "dashboard" && "sidebar-selected"
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M160-520v-280h280v280H160Zm0 360v-280h280v280H160Zm360-360v-280h280v280H520Zm0 360v-280h280v280H520ZM200-560h200v-200H200v200Zm360 0h200v-200H560v200Zm0 360h200v-200H560v200Zm-360 0h200v-200H200v200Zm360-360Zm0 160Zm-160 0Zm0-160Z" />
          </svg>
          <span>Dashboard</span>
        </NavLink>
        {/* if operator */}
        <NavLink
          id="nav-marine"
          to="/marine"
          onClick={() => {
            history.push("/marine");
            selectedMenu != "marine" && history.go(0);
          }}
          className={clsx(
            "sidebar-item",
            selectedMenu === "marine" && "sidebar-selected"
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M479.769-418Zm-291 176.462L131.23-452.615q-2.23-9.693 1.731-21.077 3.962-11.385 15.039-15.077l52-18V-680q0-27.616 18.5-46.116t46.115-18.5H400v-120h160v120h135.385q27.615 0 46.115 18.5Q760-707.616 760-680v173.231l52 18q13.308 4.923 18.077 15.807 4.769 10.885 1.769 20.347l-60.615 211.077Q735.077-253.077 706-275.423 676.923-297.769 640-340q-34.615 41.462-72.154 70.731Q530.308-240 480-240q-50.308 0-87.846-29.269Q354.615-298.538 320-340q-36.154 42.231-65.615 64.577-29.462 22.346-65.616 33.885ZM99.999-80v-40H160q42 0 83-13t77-39q36 26 77 38t83 12q42 0 83-12t77-38q36 26 77 39t83 13h60v40h-60q-42 0-82-10t-78-30q-38 20-78.5 30T480-80q-41 0-81.5-10T320-120q-38 20-78 30t-82 10h-60ZM240-520.462l240-78 240 78V-680q0-10.769-6.923-17.692t-17.692-6.923h-430.77q-10.769 0-17.692 6.923T240-680v159.538ZM480-280q47 0 78.731-32.615Q590.462-345.231 640-402q47.231 54 64.615 73.231Q722-309.538 746-295.538L790-454 480-556 169.538-454 214-296q24-14 41.385-32 17.384-18 64.615-74 50 57 81.5 89.5T480-280Z" />
          </svg>
          <span>Marine</span>
        </NavLink>
        <NavLink
          id="nav-truck"
          to="/truck"
          onClick={() => {
            history.push("/truck");
            selectedMenu != "truck" && history.go(0);
          }}
          className={clsx(
            "sidebar-item",
            selectedMenu === "truck" && "sidebar-selected"
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M227.511-195.384q-43.665 0-74.049-30.513Q123.077-256.41 123.077-300H67.692v-395.385q0-27.615 18.5-46.115 18.5-18.5 46.116-18.5h529.231v144.615h92.307l138.462 186.154V-300h-64.616q0 43.59-30.565 74.103-30.566 30.513-74.231 30.513-43.665 0-74.05-30.513Q618.461-256.41 618.461-300H332.308q0 43.846-30.566 74.231-30.565 30.385-74.231 30.385Zm.181-40.001q27 0 45.808-18.807Q292.308-273 292.308-300T273.5-345.807q-18.808-18.808-45.808-18.808t-45.807 18.808Q163.077-327 163.077-300q0 27 18.808 45.808 18.807 18.807 45.807 18.807ZM107.692-340h25.847q8.538-26.462 34.769-45.538 26.231-19.077 59.384-19.077 31.616 0 58.616 18.692T321.846-340h299.692v-380h-489.23q-9.231 0-16.923 7.692-7.693 7.693-7.693 16.923V-340Zm615.385 104.615q27 0 45.808-18.807Q787.692-273 787.692-300t-18.807-45.807q-18.808-18.808-45.808-18.808t-45.808 18.808Q658.462-327 658.462-300q0 27 18.807 45.808 18.808 18.807 45.808 18.807ZM661.539-420H850L732.308-575.385h-70.769V-420ZM364.615-530Z" />
          </svg>
          <span>Truck</span>
        </NavLink>
        <NavLink
          id="nav-rail"
          to="/rail"
          onClick={() => {
            history.push("/rail");
            selectedMenu != "rail" && history.go(0);
          }}
          className={clsx(
            "sidebar-item",
            selectedMenu === "rail" && "sidebar-selected"
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M200-355.385V-720q0-39.154 22.5-62.962 22.5-23.807 60.961-36.461 38.462-12.654 89.424-16.616Q423.846-840 480-840q58.308 0 109.115 3.961 50.808 3.962 88.924 16.616 38.115 12.654 60.038 36.461Q760-759.154 760-720v364.615q0 48.231-33.577 81.808Q692.846-240 644.615-240l60 60v20h-33.846l-80-80H369.231l-80 80h-33.846v-20l60-60q-48.231 0-81.808-33.577Q200-307.154 200-355.385ZM480-800q-117.538 0-171.154 15.577-53.615 15.577-64.692 45.961h472.615q-10.384-30.846-64.115-46.192Q598.923-800 480-800ZM240-520h220v-178.461H240V-520Zm404.615 40H240h480H644.615ZM500-520h220v-178.461H500V-520ZM340-335.385q19.077 0 31.846-12.769 12.769-12.769 12.769-31.846 0-19.077-12.769-31.846-12.769-12.769-31.846-12.769-19.077 0-31.846 12.769-12.769 12.769-12.769 31.846 0 19.077 12.769 31.846 12.769 12.769 31.846 12.769Zm280 0q19.077 0 31.846-12.769 12.769-12.769 12.769-31.846 0-19.077-12.769-31.846-12.769-12.769-31.846-12.769-19.077 0-31.846 12.769-12.769 12.769-12.769 31.846 0 19.077 12.769 31.846 12.769 12.769 31.846 12.769ZM315.385-280h329.23Q676-280 698-302q22-22 22-53.385V-480H240v124.615Q240-324 262-302q22 22 53.385 22ZM480-738.462h236.769-472.615H480Z" />
          </svg>
          <span>Rail</span>
        </NavLink>
        <NavLink
          id="nav-tank"
          to="/tank"
          onClick={() => {
            history.push("/tank");
            selectedMenu != "tank" && history.go(0);
          }}
          className={clsx(
            "sidebar-item",
            selectedMenu === "tank" && "sidebar-selected"
          )}
          exact
        >
          <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* <path fillRule="evenodd" clipRule="evenodd" d="M15.9361 7.25191C12.2987 7.25192 8.73807 8.15064 6.54213 9.8643C6.51596 9.88473 6.49004 9.92555 6.49004 9.9882V21.6145C6.49004 21.6749 6.51434 21.7151 6.53948 21.7359C8.73308 23.5514 12.2963 24.5024 15.9361 24.5024C19.5759 24.5024 23.1391 23.5514 25.3327 21.7359C25.3579 21.7151 25.3822 21.6749 25.3822 21.6145V9.98818C25.3822 9.92553 25.3563 9.88471 25.3301 9.86428C23.1341 8.1506 19.5736 7.2519 15.9361 7.25191ZM15.9361 6.09525C19.7122 6.09523 23.5651 7.0197 26.0417 8.95243C26.3715 9.20984 26.5388 9.59922 26.5388 9.98818V21.6145C26.5388 21.9913 26.3819 22.369 26.0702 22.627C23.5931 24.6771 19.7263 25.659 15.9361 25.659C12.1459 25.659 8.2791 24.6771 5.80199 22.627C5.49031 22.369 5.33337 21.9913 5.33337 21.6145V9.9882C5.33337 9.59924 5.50068 9.20985 5.83053 8.95244C8.30715 7.01974 12.1601 6.09526 15.9361 6.09525Z" fill="#00447E" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13.6228 6.26557C13.3034 6.26557 13.0445 6.5245 13.0445 6.8439V24.5794C13.0445 24.8988 13.3034 25.1577 13.6228 25.1577C13.9422 25.1577 14.2011 24.8988 14.2011 24.5794V6.8439C14.2011 6.5245 13.9422 6.26557 13.6228 6.26557ZM9.76727 7.02027C9.44786 7.02027 9.18894 7.2792 9.18894 7.5986V23.8247C9.18894 24.1441 9.44786 24.403 9.76727 24.403C10.0867 24.403 10.3456 24.1441 10.3456 23.8247V7.5986C10.3456 7.2792 10.0867 7.02027 9.76727 7.02027Z" fill="#00447E" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14.2011 11.9111C14.2011 11.5917 13.9422 11.3328 13.6228 11.3328H9.76727C9.44786 11.3328 9.18894 11.5917 9.18894 11.9111C9.18894 12.2305 9.44786 12.4895 9.76727 12.4895H13.6228C13.9422 12.4895 14.2011 12.2305 14.2011 11.9111ZM14.2011 15.7116C14.2011 15.3922 13.9422 15.1333 13.6228 15.1333H9.76727C9.44786 15.1333 9.18894 15.3922 9.18894 15.7116C9.18894 16.031 9.44786 16.2899 9.76727 16.2899H13.6228C13.9422 16.2899 14.2011 16.031 14.2011 15.7116ZM14.2011 19.512C14.2011 19.1926 13.9422 18.9337 13.6228 18.9337H9.76727C9.44786 18.9337 9.18894 19.1926 9.18894 19.512C9.18894 19.8315 9.44786 20.0904 9.76727 20.0904H13.6228C13.9422 20.0904 14.2011 19.8315 14.2011 19.512Z" fill="#00447E" />
            <path fillRule="evenodd" clipRule="evenodd" d="M19.8037 19.0476C20.3984 19.049 20.9703 18.8577 21.3982 18.5144C21.826 18.1711 22.0761 17.7029 22.0953 17.209C22.0965 16.5812 21.2838 15.1813 20.6305 14.1577C20.1917 13.4702 19.8248 12.9524 19.8248 12.9524C19.8248 12.9524 19.454 13.4676 19.0101 14.1522C18.3482 15.1731 17.5239 16.5707 17.5239 17.1989C17.5399 17.6929 17.7869 18.1622 18.2126 18.5074C18.6382 18.8525 19.2089 19.0463 19.8037 19.0476ZM19.1017 17.5129C18.9716 17.4074 18.9168 17.2977 18.9003 17.2093L19.1017 17.5129ZM18.9003 17.2093C18.9054 17.189 18.9142 17.1571 18.9293 17.112C18.9696 16.9918 19.0356 16.8329 19.1296 16.6378C19.3085 16.267 19.5538 15.8371 19.8157 15.4104C20.0737 15.8375 20.3155 16.2679 20.4917 16.6392C20.5846 16.8349 20.6499 16.9945 20.6897 17.1156C20.7045 17.1607 20.7133 17.1928 20.7184 17.2135C20.7008 17.3018 20.645 17.4109 20.5146 17.5155C20.3513 17.6465 20.0993 17.7422 19.8069 17.7415C19.5144 17.7409 19.2634 17.6441 19.1017 17.5129" fill="#00447E" /> */}
            <path fillRule="evenodd" clipRule="evenodd" d="M15.9361 7.25191C12.2987 7.25192 8.73807 8.15064 6.54213 9.8643C6.51596 9.88473 6.49004 9.92555 6.49004 9.9882V21.6145C6.49004 21.6749 6.51434 21.7151 6.53948 21.7359C8.73308 23.5514 12.2963 24.5024 15.9361 24.5024C19.5759 24.5024 23.1391 23.5514 25.3327 21.7359C25.3579 21.7151 25.3822 21.6749 25.3822 21.6145V9.98818C25.3822 9.92553 25.3563 9.88471 25.3301 9.86428C23.1341 8.1506 19.5736 7.2519 15.9361 7.25191ZM15.9361 6.09525C19.7122 6.09523 23.5651 7.0197 26.0417 8.95243C26.3715 9.20984 26.5388 9.59922 26.5388 9.98818V21.6145C26.5388 21.9913 26.3819 22.369 26.0702 22.627C23.5931 24.6771 19.7263 25.659 15.9361 25.659C12.1459 25.659 8.2791 24.6771 5.80199 22.627C5.49031 22.369 5.33337 21.9913 5.33337 21.6145V9.9882C5.33337 9.59924 5.50068 9.20985 5.83053 8.95244C8.30715 7.01974 12.1601 6.09526 15.9361 6.09525Z" fill="#000" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13.6228 6.26557C13.3034 6.26557 13.0445 6.5245 13.0445 6.8439V24.5794C13.0445 24.8988 13.3034 25.1577 13.6228 25.1577C13.9422 25.1577 14.2011 24.8988 14.2011 24.5794V6.8439C14.2011 6.5245 13.9422 6.26557 13.6228 6.26557ZM9.76727 7.02027C9.44786 7.02027 9.18894 7.2792 9.18894 7.5986V23.8247C9.18894 24.1441 9.44786 24.403 9.76727 24.403C10.0867 24.403 10.3456 24.1441 10.3456 23.8247V7.5986C10.3456 7.2792 10.0867 7.02027 9.76727 7.02027Z" fill="#000" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14.2011 11.9111C14.2011 11.5917 13.9422 11.3328 13.6228 11.3328H9.76727C9.44786 11.3328 9.18894 11.5917 9.18894 11.9111C9.18894 12.2305 9.44786 12.4895 9.76727 12.4895H13.6228C13.9422 12.4895 14.2011 12.2305 14.2011 11.9111ZM14.2011 15.7116C14.2011 15.3922 13.9422 15.1333 13.6228 15.1333H9.76727C9.44786 15.1333 9.18894 15.3922 9.18894 15.7116C9.18894 16.031 9.44786 16.2899 9.76727 16.2899H13.6228C13.9422 16.2899 14.2011 16.031 14.2011 15.7116ZM14.2011 19.512C14.2011 19.1926 13.9422 18.9337 13.6228 18.9337H9.76727C9.44786 18.9337 9.18894 19.1926 9.18894 19.512C9.18894 19.8315 9.44786 20.0904 9.76727 20.0904H13.6228C13.9422 20.0904 14.2011 19.8315 14.2011 19.512Z" fill="#000" />
            <path fillRule="evenodd" clipRule="evenodd" d="M19.8037 19.0476C20.3984 19.049 20.9703 18.8577 21.3982 18.5144C21.826 18.1711 22.0761 17.7029 22.0953 17.209C22.0965 16.5812 21.2838 15.1813 20.6305 14.1577C20.1917 13.4702 19.8248 12.9524 19.8248 12.9524C19.8248 12.9524 19.454 13.4676 19.0101 14.1522C18.3482 15.1731 17.5239 16.5707 17.5239 17.1989C17.5399 17.6929 17.7869 18.1622 18.2126 18.5074C18.6382 18.8525 19.2089 19.0463 19.8037 19.0476ZM19.1017 17.5129C18.9716 17.4074 18.9168 17.2977 18.9003 17.2093L19.1017 17.5129ZM18.9003 17.2093C18.9054 17.189 18.9142 17.1571 18.9293 17.112C18.9696 16.9918 19.0356 16.8329 19.1296 16.6378C19.3085 16.267 19.5538 15.8371 19.8157 15.4104C20.0737 15.8375 20.3155 16.2679 20.4917 16.6392C20.5846 16.8349 20.6499 16.9945 20.6897 17.1156C20.7045 17.1607 20.7133 17.1928 20.7184 17.2135C20.7008 17.3018 20.645 17.4109 20.5146 17.5155C20.3513 17.6465 20.0993 17.7422 19.8069 17.7415C19.5144 17.7409 19.2634 17.6441 19.1017 17.5129" fill="#000" />
          </svg>
          <span>Tank</span>
        </NavLink>
        <NavLink
          id="nav-reports"
          to="/reports"
          className={clsx(
            "sidebar-item",
            selectedMenu === "reports" && "sidebar-selected"
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M309.231-300h40v-180h-40v180Zm301.538 0h40v-380h-40v380ZM460-300h40v-100h-40v100Zm0-180h40v-80h-40v80ZM224.615-160Q197-160 178.5-178.5 160-197 160-224.615v-510.77Q160-763 178.5-781.5 197-800 224.615-800h510.77Q763-800 781.5-781.5 800-763 800-735.385v510.77Q800-197 781.5-178.5 763-160 735.385-160h-510.77Zm0-40h510.77q9.23 0 16.923-7.692Q760-215.385 760-224.615v-510.77q0-9.23-7.692-16.923Q744.615-760 735.385-760h-510.77q-9.23 0-16.923 7.692Q200-744.615 200-735.385v510.77q0 9.23 7.692 16.923Q215.385-200 224.615-200ZM200-760v560-560Z" />
          </svg>
          <span>Report</span>
        </NavLink>
        {/* if operator */}

        {/* <NavLink
          id="nav-invoice"
          to="/customer/invoice"
          className={clsx(
            "sidebar-item",
            selectedMenu === "invoice" && "sidebar-selected"
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M309.231-300h40v-180h-40v180Zm301.538 0h40v-380h-40v380ZM460-300h40v-100h-40v100Zm0-180h40v-80h-40v80ZM224.615-160Q197-160 178.5-178.5 160-197 160-224.615v-510.77Q160-763 178.5-781.5 197-800 224.615-800h510.77Q763-800 781.5-781.5 800-763 800-735.385v510.77Q800-197 781.5-178.5 763-160 735.385-160h-510.77Zm0-40h510.77q9.23 0 16.923-7.692Q760-215.385 760-224.615v-510.77q0-9.23-7.692-16.923Q744.615-760 735.385-760h-510.77q-9.23 0-16.923 7.692Q200-744.615 200-735.385v510.77q0 9.23 7.692 16.923Q215.385-200 224.615-200ZM200-760v560-560Z" />
          </svg>
          <span>Invoice</span>
        </NavLink> */}
        {/* <hr style={{ width: "100%" }} />
        <NavLink
          id="nav-DSA"
          to=""
          className={clsx(
            "sidebar-item",
            selectedMenu === null
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M160-520v-280h280v280H160Zm0 360v-280h280v280H160Zm360-360v-280h280v280H520Zm0 360v-280h280v280H520ZM200-560h200v-200H200v200Zm360 0h200v-200H560v200Zm0 360h200v-200H560v200Zm-360 0h200v-200H200v200Zm360-360Zm0 160Zm-160 0Zm0-160Z" />
          </svg>
          <span>DSA</span>
        </NavLink>
        <NavLink
          id="nav-tank-cleaning"
          to=""
          className={clsx(
            "sidebar-item",
            selectedMenu === null
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M160-520v-280h280v280H160Zm0 360v-280h280v280H160Zm360-360v-280h280v280H520Zm0 360v-280h280v280H520ZM200-560h200v-200H200v200Zm360 0h200v-200H560v200Zm0 360h200v-200H560v200Zm-360 0h200v-200H200v200Zm360-360Zm0 160Zm-160 0Zm0-160Z" />
          </svg>
          <span>Tank Cleaning</span>
        </NavLink>
        <NavLink
          id="nav-tips"
          to=""
          className={clsx(
            "sidebar-item",
            selectedMenu === null
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M160-520v-280h280v280H160Zm0 360v-280h280v280H160Zm360-360v-280h280v280H520Zm0 360v-280h280v280H520ZM200-560h200v-200H200v200Zm360 0h200v-200H560v200Zm0 360h200v-200H560v200Zm-360 0h200v-200H200v200Zm360-360Zm0 160Zm-160 0Zm0-160Z" />
          </svg>
          <span>TIPS</span>
        </NavLink> */}
      </div>
    </nav>
  );
};

export default Sidebar;
